export default "__VITE_ASSET__Bc5iUGwb__"